<template>
  <el-select
    v-model="optionsVal"
    :placeholder="placeholder"
    @change="handleSelect"
    :class="className"
    :filterable="filterable"
    ref="select_filter"
    :disabled="disabled"
  >
    <template v-if="special !== 'desc'">
        <el-option
        v-for="item in data"
        :key="item.value"
        :label="item.label"
        :value="item.label"
        :disabled="item.disabled"
        ></el-option>
    </template>
     <template v-else>
        <el-option
        v-for="item in data"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        :disabled="item.disabled"
        ></el-option>
     </template>

  </el-select>
</template>

<script>
export default {
  name: 'TableRSelectCommon',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    filterable: { // 是否支持搜索
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    status: {
      type: String,
      default: '' // 参数
    },
    type: {
      type: Number,
      default: 0 // 用来判断结构问题 0 默认label val  1 表示 需要处理公司格式 2 表示需要处理项目格式
    },
    value: {
      type: [Number, String, Array]

    },
    className: { // 类
      type: String,
      default: 'thead_select w150h32 h32'
    },
    special: { // 默认标准机构 label value
      type: String,
      default: 'desc'
    },
    disabled: {
      type: Boolean,
      default: false
    },

  },
  data () {
    return {
      data: [],
      optionsVal: ''
    }
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler: function () {
        this.getList()
      }
    },
    value: {
      immediate: true,
      deep: true,
      handler: function () {
        this.optionsVal = this.value
      }
    }
  },
  methods: {
    getList () {
      if (this.type === 1) {
        this.data = this.list.map(item => {
          return {
            label: item.companyName,
            value: item.id,
            disabled:item.disabled
          }
        })
      } else if (this.type === 2) {
        this.data = this.list.map(item => {
          return {
            label: item.projectName,
            value: item.id,
            disabled:item.disabled
          }
        })
      } else {
        this.data = this.list
      }
    },
    handleSelect () {
      this.$nextTick(() => {
        if (this.$refs.select_filter) {
          this.$refs.select_filter.blur()
        }
      })
      this.$emit('change', { status: this.status, value: this.optionsVal })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
